"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIT_ENDPOINT = exports.LIT_ENDPOINT_VERSION = void 0;
var LIT_ENDPOINT_VERSION;
(function (LIT_ENDPOINT_VERSION) {
    LIT_ENDPOINT_VERSION["V0"] = "/";
    LIT_ENDPOINT_VERSION["V1"] = "/v1";
})(LIT_ENDPOINT_VERSION = exports.LIT_ENDPOINT_VERSION || (exports.LIT_ENDPOINT_VERSION = {}));
exports.LIT_ENDPOINT = {
    HANDSHAKE: {
        path: '/web/handshake',
        version: LIT_ENDPOINT_VERSION.V0,
    },
    SIGN_SESSION_KEY: {
        path: '/web/sign_session_key',
        version: LIT_ENDPOINT_VERSION.V1,
    },
    EXECUTE_JS: {
        path: '/web/execute',
        version: LIT_ENDPOINT_VERSION.V1,
    },
    PKP_SIGN: {
        path: '/web/pkp/sign',
        version: LIT_ENDPOINT_VERSION.V1,
    },
    PKP_CLAIM: {
        path: '/web/pkp/claim',
        version: LIT_ENDPOINT_VERSION.V0,
    },
    SIGN_ACCS: {
        path: '/web/signing/access_control_condition',
        version: LIT_ENDPOINT_VERSION.V0,
    },
    ENCRYPTION_SIGN: {
        path: '/web/encryption/sign',
        version: LIT_ENDPOINT_VERSION.V0,
    },
};
//# sourceMappingURL=endpoints.js.map